<template>
    <div class="container">
        <div class="handle-box-search">
            <el-row class="head-search">
                <el-col :span="12" style="margin-bottom: 10px">
                    <span class="title">名称:</span>
                    <!-- 搜索司机名称-->
                    <el-input
                        v-model="search_data.title"
                        placeholder="请输入名称"
                        class="handle-input mr10"
                        @keyup.enter.native="searchwalletkeyLists"
                    ></el-input>
                </el-col>

                <el-col :span="12" style="margin-bottom: 10px">
                    <span class="title">兑换码:</span>

                    <el-input
                        v-model="search_data.wallet_key"
                        placeholder="请输入名称"
                        class="handle-input mr10"
                        @keyup.enter.native="searchwalletkeyLists"
                    ></el-input>
                </el-col>
            </el-row>

            <el-row class="head-search">
                <el-col :span="12" style="margin-bottom: 10px">
                    <span class="title">状态:</span>

                    <el-select
                        v-model="search_data.status"
                        placeholder="请选择"
                        clearable
                        @keyup.enter.native="searchwalletkeyLists"
                        style="width: 200px"
                    >
                        <el-option label="未使用" value="0"> </el-option>
                        <el-option label="已使用" value="1"> </el-option>
                        <el-option label="禁用" value="2"> </el-option>
                    </el-select>
                </el-col>
            </el-row>

            <el-row class="head-search">
                <el-col :span="24" style="margin-bottom: 10px">
                    <span class="title">起止时间:</span>

                    <el-date-picker
                        v-model="search_time"
                        type="datetimerange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="timeChange"
                        style="width: 300px"
                    >
                    </el-date-picker>
                </el-col>
                <el-col :span="24" style="margin-bottom: 10px">
                    <span class="title">创建时间:</span>

                    <el-date-picker
                        v-model="time_fixed"
                        type="datetimerange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="fixedChange"
                        style="width: 300px"
                    >
                    </el-date-picker>
                </el-col>
            </el-row>

            <el-button type="primary" icon="el-icon-search" @click="searchwalletkeyLists">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <!--            <el-button :icon="!loading?'el-icon-setting':'el-icon-loading'" @click="toExport" :disabled="loading">{{ !loading?'导出':'' }}</el-button>-->
        </div>

        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="wallet_key" label="兑换码"> </el-table-column>

            <el-table-column prop="title" label="名称"> </el-table-column>

            <el-table-column prop="price" label="金额">
                <template slot-scope="scope">
                    <span style="color: rgb(233, 161, 6)"> {{ scope.row.price }}元 </span>
                </template>
            </el-table-column>

            <el-table-column prop="city.name" label="所属城市"> </el-table-column>

            <el-table-column prop="balance" label="状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status.val == '0' ? 'warning' : scope.row.status.val == '1' ? '' : 'danger'">
                        {{ scope.row.status.alias }}</el-tag
                    >
                </template>
            </el-table-column>

            <el-table-column prop="type.alias" label="类型"> </el-table-column>

            <el-table-column prop="time.YmdHis" label="详细时间"> </el-table-column>
            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button type="danger" v-if="scope.row.status.val == '0'" @click="btnClick(scope.row.wallet_key_code, '2')"
                        >禁用</el-button
                    >
                    <el-button type="primary" v-if="scope.row.status.val == '2'" @click="btnClick(scope.row.wallet_key_code, '0')"
                        >启用</el-button
                    >
                    <el-button disabled v-if="scope.row.status.val == '1'">已使用</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>
    </div>
</template>

<script>
var _this;
export default {
    data() {
        return {
            search_time: '',
            time_fixed: '',
            loading: false,

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                title: '',
                status: '',
                end_time_fixed: '',
                time_fixed: '',
                wallet_key: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            },
            submit_data: {
                page: 1,
                title: '',
                status: '',
                end_time_fixed: '',
                time_fixed: ''
            },

            excelData: [],

            excelHead: []
        };
    },
    created() {
        _this = this;
        _this.walletkeyLists();
    },

    methods: {
        toExport() {
            _this.loading = true;
            _this.submit_data.page = 1;
            _this.getExcelData();
        },
        // 导出功能
        getExcelData() {
            _this.submit_data.title = _this.search_data.title;
            _this.submit_data.status = _this.search_data.status;
            _this.submit_data.end_time_fixed = _this.search_data.end_time_fixed;
            _this.submit_data.time_fixed = _this.search_data.time_fixed;
            _this
                .$post('/walletkey/getWalletKeyCSV', _this.submit_data)
                .then((res) => {
                    if (this.$route.path == '/walletkey') {
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.list.length; i++) {
                            _this.excelData.push({
                                title: res.data.list[i].title,
                                price: res.data.list[i].price,
                                city: res.data.list[i].city.name,
                                status: res.data.list[i].status.alias,
                                time: res.data.list[i].time.YmdHis
                            });
                        }

                        if (res.data.page * res.data.limit < res.data.count) {
                            _this.submit_data.page = res.data.page + 1;

                            _this.getExcelData();
                        } else {
                            // console.log(_this.excelData);

                            // 将数据导出execl
                            _this.exportData();

                            _this.loading = false;

                            _this.submit_data.page = 1;
                            //
                            // // 清空数据
                            _this.excelData = [];
                        }
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = ['名称', '金额', '城市', '状态', '详细时间'];
            const filterVal = ['title', 'price', 'city', 'status', 'time'];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, 'fileName');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },

        btnClick(code, val) {
            _this
                .$post('/walletkey/executeWalletkeyStatusSubmit', {
                    wallet_key_code: code,
                    status: val
                })
                .then((res) => {
                    _this.$message.success(res.msg);
                    _this.walletkeyLists();
                })
                .catch((err) => {});
        },

        fixedChange(val) {
            if (val !== null) {
                _this.search_data.time_fixed = JSON.stringify(['between'].concat(val));
            } else {
                _this.search_data.time_fixed = '';
            }
        },

        timeChange(val) {
            if (val !== null) {
                _this.search_data.end_time_fixed = JSON.stringify(['between'].concat(val));
            } else {
                _this.search_data.end_time_fixed = '';
            }
        },
        searchwalletkeyLists() {
            _this.search_data.page = 1;
            _this.walletkeyLists();
        },
        // 搜索司机日志列表
        walletkeyLists() {
            _this
                .$post('/walletkey/walletkeyLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.walletkeyLists();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-form-item.el-form-item--small {
    width: 100%;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
}

.el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
}
</style>